export default class Accordion {
  constructor(app) {
    this.app = app;

    this.headElements = [];

    this.init = this.init.bind(this);
    this.setInitialState = this.setInitialState.bind(this);
    this.destroy = this.destroy.bind(this);
    this.isExpanded = this.isExpanded.bind(this);
    this.mouseClick = this.mouseClick.bind(this);
    this.expand = this.expand.bind(this);
    this.close = this.close.bind(this);

    this.init();
  }

  init() {
    this.headElements = document.getElementsByClassName('js-accordion-head');

    for (let i = 0; i < this.headElements.length; i += 1) {
      const headElement = this.headElements[i];
      const accordion = headElement.parentElement;
      this.setInitialState(accordion);
      headElement.addEventListener('click', this.mouseClick);
    }
  }

  setInitialState(accordion) {
    if (this.isExpanded(accordion)) {
      this.expand(accordion);
    } else {
      this.close(accordion);
    }
  }

  destroy() {
    if (this.headElements) {
      for (let i = 0; i < this.headElements.length; i += 1) {
        this.headElements[i].removeEventListener('click', this.mouseClick);
      }

      this.headElements = [];
    }
  }

  isExpanded(accordion) {
    return accordion.classList.contains('--expanded');
  }

  mouseClick(event) {
    const accordion = event.currentTarget.parentElement;
    if (this.isExpanded(accordion)) {
      this.close(accordion);
    } else {
      this.expand(accordion);
    }
  }

  expand(accordion) {
    accordion.classList.add('--expanded');
    const accordionBody = accordion.querySelector('.js-accordion-body');
    accordionBody.style.maxHeight = `${accordionBody.scrollHeight + 100}px`;
  }

  close(accordion) {
    accordion.classList.remove('--expanded');
    const accordionBody = accordion.querySelector('.js-accordion-body');
    accordionBody.style.maxHeight = null;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/accordion.js